import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
const nameOf = (match)=>{
    var _ref, _ref1, _ref2;
    return (_ref = (_ref1 = (_ref2 = match === null || match === void 0 ? void 0 : match.exact) !== null && _ref2 !== void 0 ? _ref2 : match === null || match === void 0 ? void 0 : match.contains) !== null && _ref1 !== void 0 ? _ref1 : match === null || match === void 0 ? void 0 : match.fuzzy) !== null && _ref !== void 0 ? _ref : match === null || match === void 0 ? void 0 : match.startsWith;
};
const nameMatches = (service)=>{
    var _service_or;
    const entries = [];
    const single = nameOf(service.name);
    if (service.name != null && single != null) entries.push({
        name: single,
        match: service.name
    });
    for (const arm of (_service_or = service.or) !== null && _service_or !== void 0 ? _service_or : []){
        const name = nameOf(arm.name);
        if (arm.name != null && name != null) entries.push({
            name,
            match: arm.name
        });
    }
    const seen = new Set();
    return entries.filter((entry)=>seen.has(entry.name) ? false : (seen.add(entry.name), true));
};
const fromMatches = (matches)=>{
    if (matches.length === 0) return undefined;
    if (matches.length === 1) return {
        name: matches[0].match
    };
    return {
        or: matches.map((entry)=>({
                name: entry.match
            }))
    };
};
export const selectedServiceNames = (service)=>nameMatches(service).map((entry)=>entry.name);
const matchesTerm = (optionName, match, term)=>{
    const option = optionName.toLowerCase();
    const needle = term.toLowerCase();
    return match.startsWith != null ? option.startsWith(needle) : option.includes(needle);
};
const expandMatch = (param, optionNames)=>{
    let { name, match } = param;
    if (name === '' || optionNames.length === 0) return [
        name
    ];
    if (match.exact != null) {
        const exactOption = optionNames.find((optionName)=>optionName.toLowerCase() === name.toLowerCase());
        return exactOption == null ? [] : [
            exactOption
        ];
    }
    return optionNames.filter((optionName)=>matchesTerm(optionName, match, name));
};
export const resolveServiceNameSelection = (service, optionNames)=>[
        ...new Set(nameMatches(service).flatMap((entry)=>expandMatch(entry, optionNames)))
    ];
const withoutName = (service)=>{
    const { name: _omitName, or } = service, rest = _object_without_properties(service, [
        "name",
        "or"
    ]);
    const nonNameArms = (or !== null && or !== void 0 ? or : []).filter((arm)=>arm.name == null);
    return nonNameArms.length > 0 ? _object_spread_props(_object_spread({}, rest), {
        or: nonNameArms
    }) : rest;
};
export const setServiceNames = (service, names)=>{
    const existing = new Map(nameMatches(service).map((entry)=>[
            entry.name,
            entry.match
        ]));
    return fromMatches(names.map((name)=>{
        var _existing_get;
        return {
            name,
            match: (_existing_get = existing.get(name)) !== null && _existing_get !== void 0 ? _existing_get : {
                exact: name
            }
        };
    }));
};
export const rebuildServiceNames = (service, names)=>{
    var _rest_or, _namesPart_or;
    const namesPart = setServiceNames(service, names);
    const rest = withoutName(service);
    if (namesPart == null) return Object.keys(rest).length === 0 ? undefined : rest;
    if (namesPart.name != null) return _object_spread_props(_object_spread({}, rest), {
        name: namesPart.name
    });
    return _object_spread_props(_object_spread({}, rest), {
        or: [
            ...(_rest_or = rest.or) !== null && _rest_or !== void 0 ? _rest_or : [],
            ...(_namesPart_or = namesPart.or) !== null && _namesPart_or !== void 0 ? _namesPart_or : []
        ]
    });
};
